// React Component: DYPCollegeFeesTable.js
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { getDYPCollegeFeesDetailsList, saveDYPCollegeFeesDetailsList } from "../../../services/getAllApi";

const DYPCollegeFeesTable = ({ students }) => {
  const [formData, setFormData] = useState({});

  // Fetch DYP College Fees details
  const fetchDYPFeesDetails = async () => {
    try {
      const DYPFeesResponse = await getDYPCollegeFeesDetailsList();
      if (!DYPFeesResponse) {
        throw new Error("No DYP fees data received.");
      }

      const initialData = {};
      students.forEach((student) => {
        const dypCollegeFees = DYPFeesResponse.find((fee) => fee.student_id === student.id) || {};
        initialData[student.id] = {
          total_fees: dypCollegeFees.total_fees || "",
          total_fees_date: dypCollegeFees.total_fees_date || "",
          total_fees_paid: dypCollegeFees.total_fees_paid || false,
          sem1_fees: dypCollegeFees.sem1_fees || "",
          sem1_fees_date: dypCollegeFees.sem1_fees_date || "",
          sem1_fees_paid: dypCollegeFees.sem1_fees_paid || false,
          sem2_fees: dypCollegeFees.sem2_fees || "",
          sem2_fees_date: dypCollegeFees.sem2_fees_date || "",
          sem2_fees_paid: dypCollegeFees.sem2_fees_paid || false,
          sem3_fees: dypCollegeFees.sem3_fees || "",
          sem3_fees_date: dypCollegeFees.sem3_fees_date || "",
          sem3_fees_paid: dypCollegeFees.sem3_fees_paid || false,
          sem4_fees: dypCollegeFees.sem4_fees || "",
          sem4_fees_date: dypCollegeFees.sem4_fees_date || "",
          sem4_fees_paid: dypCollegeFees.sem4_fees_paid || false,
          balance_fees: dypCollegeFees.balance_fees || "",
          balance_fees_date: dypCollegeFees.balance_fees_date || "",
          balance_fees_paid: dypCollegeFees.balance_fees_paid || false,
        };
      });

      setFormData(initialData);
    } catch (error) {
      console.error("Error fetching DYP College fees details:", error);
    }
  };

  useEffect(() => {
    fetchDYPFeesDetails();
  }, [students]);

  // Handle input changes
  const handleChange = (e, studentId) => {
    const { name, value, type, checked } = e.target;
    const updatedValue = type === "checkbox" ? checked : value;

    setFormData((prevData) => {
      const updatedStudent = {
        ...prevData[studentId],
        [name]: updatedValue,
      };

      const totalFees = parseFloat(updatedStudent.total_fees) || 0;
      const sem1_fees = parseFloat(updatedStudent.sem1_fees) || 0;
      const sem2_fees = parseFloat(updatedStudent.sem2_fees) || 0;
      const sem3_fees = parseFloat(updatedStudent.sem3_fees) || 0;
      const sem4_fees = parseFloat(updatedStudent.sem4_fees) || 0;

      let balanceFees = totalFees - (sem1_fees + sem2_fees + sem3_fees + sem4_fees);
      if (balanceFees <= 0) balanceFees = 0;

      updatedStudent.balance_fees = balanceFees;

      return { ...prevData, [studentId]: updatedStudent };
    });
  };

  const handleSubmit = async () => {
    const feesDataArray = Object.keys(formData).map((studentId) => ({
      student_id: parseInt(studentId, 10),
      ...formData[studentId],
    }));

    try {
      await saveDYPCollegeFeesDetailsList(feesDataArray);
      Swal.fire("Success", "Fees Data saved successfully!", "success");
      await fetchDYPFeesDetails();
    } catch (error) {
      Swal.fire("Error", "Failed to save data", "error");
    }
  };

  return (
    <div>
      <button onClick={handleSubmit} className="handle-btn">
        <p className="button-save">Save Data</p>
      </button>
      <div className="table-container-MBA-Students-list">
        <table>
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Student ID</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>DYP Total Fees/Date</th>
              <th>DYP SEM1 Fees/Date</th>
              <th>DYP SEM2 Fees/Date</th>
              <th>DYP SEM3 Fees/Date</th>
              <th>DYP SEM4 Fees/Date</th>
              <th>Balance Fees</th>
            </tr>
          </thead>
          <tbody>
            {students.map((student, index) => (
              <tr key={student.id}>
                <td>{index + 1}</td>
                <td>{student.studentId}</td>
                <td>{student.name}</td>
                <td>{student.mobile}</td>
                {[ 
                  { field: "total_fees", dateField: "total_fees_date", checkField: "total_fees_paid" },
                  { field: "sem1_fees", dateField: "sem1_fees_date", checkField: "sem1_fees_paid" },
                  { field: "sem2_fees", dateField: "sem2_fees_date", checkField: "sem2_fees_paid" },
                  { field: "sem3_fees", dateField: "sem3_fees_date", checkField: "sem3_fees_paid" },
                  { field: "sem4_fees", dateField: "sem4_fees_date", checkField: "sem4_fees_paid" },
                  { field: "balance_fees", dateField: "balance_fees_date", checkField: "balance_fees_paid" },
                ].map((DYPCollegefee, idx) => (
                  <td key={idx}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", padding: "5px" }}>
                      <input
                        type="number"
                        name={DYPCollegefee.field}
                        value={formData[student.id]?.[DYPCollegefee.field] ?? 0}
                        onChange={(e) => handleChange(e, student.id)}
                        style={{
                          width: "120px",
                          textAlign: "center",
                          fontWeight: DYPCollegefee.field === "balance_fees" ? "bold" : "normal",
                          color: DYPCollegefee.field === "balance_fees" ? "red" : "black",
                        }}
                        disabled={DYPCollegefee.field === "balance_fees"}
                      />
                      <input
                        type="date"
                        name={DYPCollegefee.dateField}
                        value={formData[student.id]?.[DYPCollegefee.dateField] || ""}
                        onChange={(e) => handleChange(e, student.id)}
                        style={{ width: "120px", textAlign: "center" }}
                      />
                      <input
                        type="checkbox"
                        name={DYPCollegefee.checkField}
                        checked={formData[student.id]?.[DYPCollegefee.checkField] || false}
                        onChange={(e) => handleChange(e, student.id)}
                        style={{
                          width: "18px",
                          height: "18px",
                          cursor: "pointer",
                          accentColor: formData[student.id]?.[DYPCollegefee.checkField] ? "green" : "red",
                        }}
                      />
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DYPCollegeFeesTable;
